import request from "@/utils/request";

export function getDriverState(params) {
  return request({
    url: "/tic/v1.0/annual-report",
    baseURL: process.env.VUE_APP_YEAR_REVIEW,
    method: "get",
    params,
  });
}